import { Directive, HostBinding, HostListener, Input } from '@angular/core';

@Directive({
 selector:'[expandMenu]'
})
export class ExpandMenu{

 @Input() bool: any;   

 @HostBinding('class.active_drop') isOpen = false;
 @HostListener('click') toggleOpen($event){
    if (this.bool == undefined) {
        this.isOpen = !this.isOpen;
    } else {
        this.isOpen = !this.bool;
    }

 }

}